var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "access-control" } },
    [
      _c(
        "a-tabs",
        {
          staticClass: "access-control-tabs",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "a-tab-pane",
            {
              key: "whitelist",
              attrs: { tab: _vm.$t("settings.ipWhitelist") },
            },
            [
              _c("supsis-table", {
                attrs: { columns: _vm.cols(), rows: _vm.getFilteredRows() },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("a-input-search", {
                              staticClass: "search-input",
                              attrs: { placeholder: _vm.$t("message.search") },
                              on: { search: _vm.onSearch },
                              model: {
                                value: _vm.searchText,
                                callback: function ($$v) {
                                  _vm.searchText = $$v
                                },
                                expression: "searchText",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "page-header" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("settings.accessControl"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "subtitle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("settings.accessControlSubTitles")
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "SupsisButton",
                              {
                                attrs: { ghost: "" },
                                on: { click: _vm.showModalWithoutEdit },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("settings.whiteListAdd")) +
                                    "\n                            "
                                ),
                                _c("md-icon", [_vm._v("add")]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "sessions",
              attrs: { tab: _vm.$t("sessions.sessionManagement") },
            },
            [
              _c("div", { staticClass: "sessions-tab" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "sessions-header d-flex justify-content-between align-items-center mb-3",
                  },
                  [
                    _c("div", { staticClass: "page-header" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("sessions.sessionManagement"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "subtitle" }, [
                        _vm._v(_vm._s(_vm.$t("sessions.allSessionsDesc"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sessions-filters d-flex align-items-center",
                      },
                      [
                        _c(
                          "a-select",
                          {
                            staticStyle: {
                              width: "250px",
                              "margin-right": "12px",
                            },
                            attrs: {
                              placeholder: _vm.$t("sessions.filterByUser"),
                              allowClear: "",
                              showSearch: "",
                              optionFilterProp: "children",
                            },
                            on: { change: _vm.onUserFilterChange },
                            model: {
                              value: _vm.selectedUserId,
                              callback: function ($$v) {
                                _vm.selectedUserId = $$v
                              },
                              expression: "selectedUserId",
                            },
                          },
                          _vm._l(_vm.usersList, function (user) {
                            return _c(
                              "a-select-option",
                              { key: user._id, attrs: { value: user._id } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(user.name || user.email) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "default",
                              icon: "reload",
                              loading: _vm.sessionsLoading,
                            },
                            on: { click: _vm.fetchAllSessions },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.refresh")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.sessionsLoading
                  ? _c(
                      "div",
                      { staticClass: "sessions-loading" },
                      [_c("a-spin", { attrs: { size: "large" } })],
                      1
                    )
                  : _vm.allSessions.length === 0
                  ? _c(
                      "div",
                      { staticClass: "sessions-empty" },
                      [
                        _c("a-empty", {
                          attrs: {
                            description: _vm.$t("sessions.noActiveSessions"),
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "sessions-list" },
                      _vm._l(_vm.allSessions, function (session) {
                        return _c("SessionCard", {
                          key: session._id,
                          attrs: { session: session, showUserInfo: true },
                          on: { revoke: _vm.handleAdminRevoke },
                        })
                      }),
                      1
                    ),
                _vm._v(" "),
                _vm.sessionsPagination.totalPages > 1
                  ? _c(
                      "div",
                      { staticClass: "sessions-pagination mt-3" },
                      [
                        _c("a-pagination", {
                          attrs: {
                            current: _vm.sessionsPagination.page,
                            total: _vm.sessionsPagination.total,
                            pageSize: _vm.sessionsPagination.perPage,
                          },
                          on: { change: _vm.onSessionPageChange },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "white-list-form",
                title: _vm.$t("settings.whiteList"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "ipAddress" } }, [
                  _vm._v(_vm._s(_vm.$t("message.ipAddress"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ip-address" },
                  [
                    _c("a-input", {
                      attrs: { id: "ipAddress", placeholder: "0.0.0.0" },
                      model: {
                        value: _vm.form.ipAddress,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ipAddress", $$v)
                        },
                        expression: "form.ipAddress",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "detect-ip-btn",
                        attrs: { primary: "" },
                        on: { click: _vm.takeIpAddress },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("settings.detectIpAddress")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "description" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.description"))),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: { id: "description" },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "SupsisButton",
                    { attrs: { primary: "" }, on: { click: _vm.handleSave } },
                    [_vm._v(" " + _vm._s(_vm.$t("message.save")) + " ")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }